import { defineStore } from 'pinia';
import { authService, type AuthUser } from '../services/auth';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    initialized: false,
    loading: false,
    authenticated: false,
    online: typeof navigator === 'undefined' || navigator.onLine,
    user: null as AuthUser | null,
    error: '',
  }),
  getters: {
    displayName: (state) => state.user?.name || state.user?.username || state.user?.email || 'Usuario',
  },
  actions: {
    async bootstrap() {
      if (this.initialized) return this.authenticated;
      this.loading = true;
      try {
        const state = await authService.bootstrap();
        this.authenticated = Boolean(state.authenticated);
        this.user = state.user;
        this.online = state.authenticated ? this.online : (navigator.onLine !== false);
        this.error = '';
      } catch (error) {
        this.authenticated = false;
        this.user = null;
        this.error = error instanceof Error ? error.message : 'No se pudo comprobar la sesión.';
      } finally {
        this.initialized = true;
        this.loading = false;
      }
      return this.authenticated;
    },
    applyUser(user: AuthUser | null) {
      this.user = user;
      this.authenticated = Boolean(user);
    },
    async login(identifier: string, password: string) {
      this.loading = true; this.error = '';
      try { const result = await authService.login(identifier, password) as { user: AuthUser }; this.applyUser(result.user); this.online = true; return result; }
      catch (error) { this.error = error instanceof Error ? error.message : 'No se pudo iniciar sesión.'; throw error; }
      finally { this.loading = false; }
    },
    async register(username: string, email: string, password: string, name = '') {
      this.loading = true; this.error = '';
      try { const result = await authService.register(username, email, password, name) as { user: AuthUser }; this.applyUser(result.user); this.online = true; return result; }
      catch (error) { this.error = error instanceof Error ? error.message : 'No se pudo crear la cuenta.'; throw error; }
      finally { this.loading = false; }
    },
    async logout() { await authService.logout(); this.applyUser(null); this.error = ''; },
    async updateProfile(name: string) { const user = await authService.updateProfile(name); this.applyUser(user); return user; },
    async changePassword(currentPassword: string, newPassword: string) { await authService.changePassword(currentPassword, newPassword); this.applyUser(null); },
  },
});
